<template>
  <div class="home">
    <div class="web" id="www">
      <div class="gallery">
        <h1><span>web</span></h1>

        <div
          v-for="(site, i) in sites"
          :key="i"
          class="acc-item"
          :class="{ open: openIndex === i }"
        >
          <div class="acc-header" @click="toggleOpen(i)">
            <h4>{{ site.url }}</h4>
            <span class="acc-chevron">&#8964;</span>
          </div>

          <div class="acc-body">
            <figure
              class="site"
              @mouseover="hoverIndex = i"
              @mouseleave="hoverIndex = null"
              :class="{ hover: hoverIndex === i }"
            >
              <img :src="site.img" :alt="site.title" />
              <div class="title">
                <div>
                  <h2>{{ site.title }}</h2>
                  <h4>{{ site.url }}</h4>
                </div>
              </div>
              <figcaption>
                <p>{{ site.description }}</p>
              </figcaption>
              <a :href="site.href" target="_blank"></a>
            </figure>
          </div>
        </div>
      </div>
    </div>
    <hr />
    <div class="design" id="dsgn">
      <div class="design-box">
        <h1><span>dsgn</span></h1>

        <div class="design-grid">
          <figure
            v-for="(dsgn, i) in dsgns"
            :key="i"
            class="dsgn-card"
            @mouseenter="hoveredDsgn = dsgn"
            @mouseleave="hoveredDsgn = null"
            @click="$router.push(dsgn.route)"
          >
            <img :src="dsgn.img" :alt="dsgn.title" />
            <div class="dsgn-label">
              <span>{{ dsgn.title }}</span>
            </div>
          </figure>
        </div>

        <Teleport to="body">
          <Transition name="overlay-fade">
            <div
              v-if="hoveredDsgn"
              class="dsgn-overlay"
              @mouseenter="hoveredDsgn = hoveredDsgn"
              @mouseleave="hoveredDsgn = null"
            >
              <img :src="hoveredDsgn.img" :alt="hoveredDsgn.title" />
              <div class="overlay-caption">
                <h2>{{ hoveredDsgn.title }}</h2>
                <p>{{ hoveredDsgn.description }}</p>
              </div>
            </div>
          </Transition>
        </Teleport>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeView",

  mounted() {
    document.documentElement.style.overflow = "auto";
    document.body.style.overflow = "auto";
  },

  beforeUnmount() {
    document.body.style.overflow = "";
    document.documentElement.style.overflow = "";
  },

  data() {
    return {
      openIndex: null,
      hoverIndex: null,

      sites: [
        {
          img: require("@/assets/screen_pomelo.jpg"),
          title: "",
          url: "pomelo.org",
          description: "Dsgn & Dev: HTML, CSS, Javascript, Vue CLI",
          href: "https://pomelo.org",
        },
        {
          img: require("@/assets/altroyjeromedotcom.jpg"),
          title: "",
          url: "altroyjerome.com",
          description: "Dsgn & Dev: Wordpress, CSS, Javascript",
          href: "https://altroyjerome.com",
        },

        {
          img: require("@/assets/screen_dlms.jpg"),
          title: "",
          url: "dlms.works",
          description: "Dsgn & Dev: HTML, CSS, Javascript, Vue CLI",
          href: "https://dlms.works",
        },
        {
          img: require("@/assets/screen_lodig.jpg"),
          title: "",
          url: "lodig.tech",
          description: "Dsgn & Dev: HTML, CSS, Javascript, Vue CLI",
          href: "https://lodig.tech",
        },
      ],

      dsgns: [
        {
          img: require("@/assets/aye-shk14a.png"),
          title: "Shaddock 14",
          description: "record cover and label design. Shaddock Records",
          // route: "/design/shaddock-14",
        },
        {
          img: require("@/assets/aye-shk14b.png"),
          title: "Shaddock 14",
          description: "record cover and label design. Shaddock Records",
          // route: "/design/shaddock-14",
        },
        {
          img: require("@/assets/aye-shk14a-close.png"),
          title: "Shaddock 14",
          description: "label design. Shaddock Records",
          // route: "/design/shaddock-14",
        },
        {
          img: require("@/assets/aye-shk14b-close.png"),
          title: "Shaddock 14",
          description: "label design. Shaddock Records",
          // route: "/design/shaddock-14",
        },
        {
          img: require("@/assets/pom52_vinylA.jpg"),
          title: "Pomelo 52",
          description: "label design. Pomelo Records",
          // route: "/design/shaddock-14",
        },
        {
          img: require("@/assets/pom52_vinylAA.jpg"),
          title: "Pomelo 52",
          description: "label design. Pomelo Records",
          // route: "/design/shaddock-14",
        },
      ],
      hoveredDsgn: null,
    };
  },
  methods: {
    toggleOpen(i) {
      this.openIndex = this.openIndex === i ? null : i;
    },
  },
};
</script>

<style scoped>
.home {
  color: #fff;
  display: flex;
  flex-direction: column;
  gap: 3rem;
  padding: 2rem;
  min-height: 100vh;
  box-sizing: border-box;
  padding-bottom: 100px;
  background-color: #fefeff;
  margin: 50px;
}
hr.stylized {
  border: none;
  height: 3px;
  background-color: #a8a8aa;
  width: 60%;
  margin: 20px auto;
}
.web .gallery h1,
.design h1 {
  font-size: 1rem;
  margin: 0 0 1px 0;
  text-align: left;
}
.web .gallery h1 span {
  color: #fff;
  border-radius: 2px;
}

h1 span {
  background-color: #9da9ca;
  padding: 5px 10px;
  color: #fff;
  border-radius: 2px;
  /* opacity: 0.65; */
}

.gallery {
  width: 70%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

figure.site {
  position: relative;
  overflow: hidden;
  margin: 10px 0;
  min-width: 500px;
  width: 100%;
  color: #ffffff;
  text-align: center;
  font-size: 16px;
  background-color: #17213c;
}
figure.site *,
figure.site *:before,
figure.site *:after {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-transition: all 0.55s ease;
  transition: all 0.55s ease;
}
figure.site img {
  max-width: 100%;
  backface-visibility: hidden;
  vertical-align: top;
  opacity: 0.9;
}
figure.site .title {
  position: absolute;
  top: 58%;
  left: 25px;
  padding: 5px 10px 10px;
}
figure.site .title:before,
figure.site .title:after {
  height: 2px;
  width: 400px;
  position: absolute;
  content: "";
  background-color: #ffffff;
}
figure.site .title:before {
  top: 0;
  left: 10px;
  -webkit-transform: translateX(100%);
  transform: translateX(370%);
}
figure.site .title:after {
  bottom: 0;
  right: 10px;
  -webkit-transform: translateX(-100%);
  transform: translateX(-300%);
}
figure.site .title div:before,
figure.site .title div:after {
  width: 2px;
  height: 300px;
  position: absolute;
  content: "";
  background-color: #ffffff;
}
figure.site .title div:before {
  top: 10px;
  right: 0;
  -webkit-transform: translateY(100%);
  transform: translateY(300%);
}
figure.site .title div:after {
  bottom: 10px;
  left: 0;
  -webkit-transform: translateY(-100%);
  transform: translateY(-300%);
}
figure.site h2,
figure.site h4 {
  margin: 0;
  text-transform: uppercase;
}
figure.site h2 {
  font-weight: 300;
}
figure.site h4 {
  font-weight: 400;
  background-color: #ffffff;
  padding: 5px 10px;
  color: #17213c;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.55s ease, visibility 0.55s ease;
}
figure.site:hover h4,
figure.site.hover h4 {
  opacity: 1;
  visibility: visible;
}
figure.site figcaption {
  position: absolute;
  bottom: 42%;
  left: 25px;
  text-align: left;
  opacity: 0;
  padding: 5px 60px 5px 10px;
  font-size: 0.8em;
  font-weight: 500;
  letter-spacing: 1.5px;
}
figure.site figcaption p {
  margin: 0;
}
figure.site a {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
figure.site:hover img,
figure.site.hover img {
  zoom: 1;
  filter: alpha(opacity=35);
  -webkit-opacity: 0.35;
  opacity: 0.35;
}
figure.site:hover .title:before,
figure.site.hover .title:before,
figure.site:hover .title:after,
figure.site.hover .title:after,
figure.site:hover .title div:before,
figure.site.hover .title div:before,
figure.site:hover .title div:after,
figure.site.hover .title div:after {
  -webkit-transform: translate(0, 0);
  transform: translate(0, 0);
}
figure.site:hover .title:before,
figure.site.hover .title:before,
figure.site:hover .title:after,
figure.site.hover .title:after {
  -webkit-transition-delay: 0.15s;
  transition-delay: 0.15s;
}
figure.site:hover figcaption,
figure.site.hover figcaption {
  opacity: 1;
  -webkit-transition-delay: 0.2s;
  transition-delay: 0.2s;
}
.design .design-box h1 span {
  color: #fff;
}
.design-box {
  width: 70%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.design-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 1rem;
}

.dsgn-card {
  position: relative;
  margin: 0;
  overflow: hidden;
  cursor: pointer;
  aspect-ratio: 1 / 1;
  background: #111;
  opacity: 0.8;
}

.dsgn-card img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.4s ease, opacity 0.4s ease;
}

.dsgn-card:hover img {
  transform: scale(1.05);
  opacity: 0.6;
}

.dsgn-label {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 8px 12px;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.75));
  color: #fff;
  font-size: 0.75rem;
  letter-spacing: 1px;
  text-transform: uppercase;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.dsgn-card:hover .dsgn-label {
  opacity: 1;
}
.dsgn-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: rgba(161, 161, 163, 0.88);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 1.5rem;
  pointer-events: none;
}
.dsgn-overlay img {
  max-width: 80vw;
  max-height: 75vh;
  object-fit: contain;
  box-shadow: 0 8px 60px rgba(0, 0, 0, 0.6);
}
.overlay-caption {
  text-align: center;
  color: #fff;
}
.overlay-caption h2 {
  margin: 0 0 4px;
  font-size: 1rem;
  font-weight: 300;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #fff;
  font-family: "Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande",
    "Lucida Sans", Arial, sans-serif;
}
.overlay-caption p {
  margin: 0;
  font-size: 0.75rem;
  color: #fff;
  font-family: "Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande",
    "Lucida Sans", Arial, sans-serif;
}
.overlay-fade-enter-active,
.overlay-fade-leave-active {
  transition: opacity 0.25s ease;
}
.overlay-fade-enter-from,
.overlay-fade-leave-to {
  opacity: 0;
}
#www,
#dsgn {
  scroll-margin-top: 80px;
}
.acc-item {
  border-bottom: 1px solid #e0e0e0;
}

.acc-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  cursor: pointer;
  background: #fefeff;
  transition: background 0.2s;
  background: #9da9ca;
  opacity: 0.7;
}

.acc-header:hover {
  background: #17213c;
  background-color: #17213c;
}

.acc-header h4 {
  margin: 0;
  font-size: 0.85rem;
  font-weight: 500;
  color: #fefeff;
  background: none;
  padding: 0;
  text-transform: none;
}

.acc-chevron {
  font-size: 1.1rem;
  color: #a8a8aa;
  transition: transform 0.3s ease;
}

.acc-item.open .acc-chevron {
  transform: rotate(180deg);
}

.acc-body {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.45s ease;
}

.acc-item.open .acc-body {
  max-height: 1000px;
}
.acc-body .site img {
  width: 100%;
  height: auto;
  display: block;
  object-fit: contain;
  transform: scale(1);
}
@media (max-width: 768px) {
  .home {
    margin: 10px;
    padding: 1rem;
  }

  .gallery,
  .design-box {
    width: 100%;
  }

  figure.site {
    min-width: unset;
  }
}
</style>
